import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["as", "caption", "kind", "children", "id"];
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useId } from '../hooks';
import { kinds } from './constants';
import TangramLogo from './TangramLogo';
import RDStationLogo from './RDStationLogo';
import RDStationAppstoreLogo from './RDStationAppstoreLogo';
import RDStationCRMLogo from './RDStationCRMLogo';
import RDStationContasLogo from './RDStationContasLogo';
import RDStationMarketingLogo from './RDStationMarketingLogo';
const Root = styled.figure.withConfig({
  displayName: "Brand__Root",
  componentId: "sc-gomep5-0"
})(["display:inline-flex;padding:0;margin:0;justify-content:center;align-items:center;height:32px;border-radius:0;border:0;background:transparent;> *{display:block;height:100%;width:auto;}"]);
const logos = {
  [kinds.Tangram]: TangramLogo,
  [kinds.RDStation]: RDStationLogo,
  [kinds.RDStationAppstore]: RDStationAppstoreLogo,
  [kinds.RDStationCRM]: RDStationCRMLogo,
  [kinds.RDStationContas]: RDStationContasLogo,
  [kinds.RDStationMarketing]: RDStationMarketingLogo
};
const Brand = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    as,
    caption: captionProp,
    kind,
    children,
    id: idProp
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  const id = useId(idProp);
  const Logo = logos[kind];
  const caption = captionProp || (Logo === null || Logo === void 0 ? void 0 : Logo.caption);
  return /*#__PURE__*/React.createElement(Root, _extends({
    "aria-label": caption,
    title: caption
  }, rest, {
    id: id,
    as: as,
    ref: ref
  }), !children && /*#__PURE__*/React.createElement(Logo, {
    title: caption,
    titleId: "logo-title-".concat(id)
  }), children);
});
Brand.displayName = 'Brand';
Brand.Style = Root;
Brand.kinds = kinds;
Brand.defaultProps = {
  kind: Brand.kinds.Tangram,
  as: 'figure'
};
process.env.NODE_ENV !== "production" ? Brand.propTypes = {
  /**
   * Sets children.
   */
  children: PropTypes.node,

  /**
   * Set element type to be rendered for this component. By default it will render a `figure` element.
   * Additional properties can be passed to the component according to the element specified in this property.
   *
   * @example
   * <Brand as="a" href="/" />
   */
  as: PropTypes.oneOfType([PropTypes.elementType, PropTypes.string]),

  /**
   * Adds a component description for accessibility.
   * The brand name is a good fit for this property.
   */
  caption: PropTypes.string,

  /**
   * Automatically includes the brand image for the respective kind.
   */
  kind: PropTypes.oneOf([Brand.kinds.Tangram, Brand.kinds.RDStation, Brand.kinds.RDStationAppstore, Brand.kinds.RDStationCRM, Brand.kinds.RDStationContas, Brand.kinds.RDStationMarketing])
} : void 0;
export default Brand;